import React, { useState, useEffect } from 'react';
import { Form, Button, Row, Col, Container, Alert, Nav, Navbar, Tab, Table, Modal, ButtonGroup } from 'react-bootstrap';
import api from '../../redux/actions/configApi';
import Loader from '../loading';
const FormEmail = () => {
    // Estados para cada campo do formulário
    const [mailer, setMailer] = useState('smtp');
    const [host, setHost] = useState('');
    const [port, setPort] = useState('');
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [encryption, setEncryption] = useState('');
    const [fromAddress, setFromAddress] = useState('');
    const [fromName, setFromName] = useState('Pentalobe');
    const [errors, setErrors] = useState([]);
    const [loading, setLoading] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Dados a serem enviados para o back-end
        const emailConfig = {
            mailer,
            host,
            port,
            username,
            password,
            encryption,
            fromAddress,
            fromName
        };

        try {
            // Chamada de API para enviar os dados
            setLoading(true)
            const response = await api.post('email-config', emailConfig);

            if (response.status === 200) {
                setLoading(false)
                setErrors([])
                setSuccessMessage('Configurações de e-mail salvas com sucesso!');
            }
        } catch (error) {
            setLoading(false)
            setSuccessMessage('');

            if (error.response && error.response.status === 422) {
                const validationErrors = error.response.data.errors;
                const errorMessages = [];

                for (let field in validationErrors) {
                    if (validationErrors.hasOwnProperty(field)) {
                        errorMessages.push(`${validationErrors[field].join(', ')}`);
                    }
                }

                setErrors(errorMessages);
            } else {
                setErrors(['Erro ao salvar as configurações. Por favor, tente novamente.']);
            }
        }
    };

    useEffect(() => {
        // Fetch current email configurations from the backend
        setLoading(true)
        const fetchEmailConfig = async () => {
            try {
                const response = await api.get('email-config-front');
                const config = response.data;

                setMailer(config.mailer);
                setHost(config.host);
                setPort(config.port);
                setUsername(config.username);
                setEncryption(config.encryption);
                setFromAddress(config.fromAddress);
                setFromName(config.fromName);
                setLoading(false)
            } catch (error) {
                setLoading(false)
                console.error('Erro ao obter configurações de e-mail:', error);
            }
        };

        fetchEmailConfig();
    }, []);

    return (
        <div className="dashboard-container">
            <div className={`loading ${loading ? 'loading-active' : ''}`}>
                <Loader loading={loading}/>
                <Form onSubmit={handleSubmit} style={{ fontSize: '0.5em' }}>
                    <h5 className="mb-4">Configurações de E-mail</h5>
                    <Row>
                        {successMessage && (
                            <Alert variant="success" onClose={() => setSuccessMessage('')} dismissible className='text-center'>
                                {successMessage}
                            </Alert>
                        )}

                        {errors.length > 0 && (
                            <Alert variant="danger" onClose={() => setErrors([])} dismissible className='text-center'>
                                {errors.map((error, index) => (
                                    <div key={index}>{error}</div>
                                ))}
                            </Alert>
                        )}
                        <Col md={6}>
                            <Form.Group controlId="formMailer" className="mb-3">
                                <Form.Label>Mailer</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={mailer}
                                    onChange={(e) => setMailer(e.target.value)}
                                    placeholder=""
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group controlId="formHost" className="mb-3">
                                <Form.Label>Host</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={host}
                                    onChange={(e) => setHost(e.target.value)}
                                    placeholder=""
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6}>
                            <Form.Group controlId="formPort" className="mb-3">
                                <Form.Label>Porta</Form.Label>
                                <Form.Control
                                    type="number"
                                    value={port}
                                    onChange={(e) => setPort(e.target.value)}
                                    placeholder=""
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group controlId="formEncryption" className="mb-3">
                                <Form.Label>Encriptação</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={encryption}
                                    onChange={(e) => setEncryption(e.target.value)}
                                    placeholder=""
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6}>
                            <Form.Group controlId="formUsername" className="mb-3">
                                <Form.Label>Usuário</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={username}
                                    onChange={(e) => setUsername(e.target.value)}
                                    placeholder="Usuário SMTP"
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group controlId="formPassword" className="mb-3">
                                <Form.Label>Senha</Form.Label>
                                <Form.Control
                                    type="password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    placeholder="Senha SMTP"
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6}>
                            <Form.Group controlId="formFromAddress" className="mb-3">
                                <Form.Label>E-mail de Remetente</Form.Label>
                                <Form.Control
                                    type="email"
                                    value={fromAddress}
                                    onChange={(e) => setFromAddress(e.target.value)}
                                    placeholder=""
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group controlId="formFromName" className="mb-3">
                                <Form.Label>Nome de Remetente</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={fromName}
                                    onChange={(e) => setFromName(e.target.value)}
                                    placeholder="Nome do Remetente"
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Button variant="primary" type="submit">
                        {loading ? 'Salvando' : 'Salvar Configurações'}
                    </Button>
                </Form>
            </div>
        </div>
    );
};

export default FormEmail;
